import React from "react";
import "./Footer.css";
import { useApp } from "../../AppContext/AppContext";

const Footer = () => {
  const { handleAppSelect } = useApp();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  const handleSelectAndScroll = (appName) => {
    handleAppSelect(appName);
    // First scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Then after a short delay, scroll to instructions
    setTimeout(() => {
      scrollToSection('instructions');
    }, 100);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* <div className="footer-top">
          <div className="footer-left">
            <div className="footer-brand">
              <img
                src="/assets/footerLogo.png"
                alt="All Video Downloader"
                className="footer-logo"
                onClick={scrollToTop}
                style={{ cursor: 'pointer' }}
              />
              <div className="footer-brand-content">
                <h2 className="footer-brand-title">All Video Downloader</h2>
              </div>
            </div>
            <div className="footer-social">
              <h3 className="footer-social-title">Follow Us</h3>
              <div className="footer-social-icons">
                <a
                  href="https://facebook.com"
                  aria-label="Visit our Facebook page"
         
                >
                  <img src="/assets/footerFacebook.svg" alt="" />
                </a>
                <a
                  href="https://twitter.com"
                  aria-label="Visit our Twitter page"
                
                >
                  <img src="/assets/footerTwitter.svg" alt="" />
                </a>
                <a
                  href="https://tiktok.com"
                  aria-label="Visit our TikTok page"
                >
                  <img src="/assets/footerTiktok.svg" alt="" />
                </a>
              </div>
            </div>
          </div>

          <nav className="footer-nav" aria-label="Footer navigation">
            <div className="footer-nav-column">
              <h3 className="footer-nav-title">Important Links</h3>
              <ul>
                <li>
                  <a onClick={scrollToTop} style={{ cursor: 'pointer' }}>Home</a>
                </li>
                <li>
                  <a href="https://vidoxe.com/" target="_blank" rel="noopener noreferrer">Privacy & Policy</a>
                </li>
                <li>
                  <a href="https://vidoxe.com/" target="_blank" rel="noopener noreferrer">Terms & Condition</a>
                </li>
              </ul>
            </div>

            <div className="footer-nav-column">
              <h3 className="footer-nav-title">How To Download</h3>
              <ul>
                <li>
                  <a onClick={() => handleSelectAndScroll('Instagram')} style={{ cursor: 'pointer' }}>Insta Downloader</a>
                </li>
                <li>
                  <a onClick={() => handleSelectAndScroll('Facebook')} style={{ cursor: 'pointer' }}>Facebook Downloader</a>
                </li>
                <li>
                  <a onClick={() => handleSelectAndScroll('X-twitter')} style={{ cursor: 'pointer' }}>X-twitter Downloader</a>
                </li>
                <li>
                  <a onClick={() => handleSelectAndScroll('Tiktok')} style={{ cursor: 'pointer' }}>Tiktok Downloader</a>
                </li>
                <li>
                  <a onClick={() => handleSelectAndScroll('Bitchute')} style={{ cursor: 'pointer' }}>Bitchute Downloader</a>
                </li>
                <li>
                  <a onClick={() => handleSelectAndScroll('Dailymotion')} style={{ cursor: 'pointer' }}>Daily Motion Downloader</a>
                </li>
              </ul>
            </div>
          </nav>
        </div> */}

        <div className="footer-divider" role="separator"></div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            Copyright © {new Date().getFullYear()} Video Downloader. All rights
            reserved.
          </p>
            


        </div>
        
      </div>
      
    </footer>
  );
};

export default Footer;
